import { render } from "./PrintableLicenseApplication.vue?vue&type=template&id=22fc3ae8&scoped=true"
import script from "./PrintableLicenseApplication.vue?vue&type=script&lang=js"
export * from "./PrintableLicenseApplication.vue?vue&type=script&lang=js"

import "./PrintableLicenseApplication.vue?vue&type=style&index=0&id=22fc3ae8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fc3ae8"]])

export default __exports__